import { FormattedMessage } from 'react-intl'

import arrow from '@static/vectors/go.svg'
import './CtaButton.css'

export default function CtaButton({
  filled = true,
  text = 'cta-button.text',
  withIcon = false
}: {
  filled?: boolean
  text?: string
  withIcon?: boolean
}) {
  return (
    <a
      target="_blank"
      href="https://adigital.typeform.com/to/l6QUWo9l?st=h"
      className={`cta-button button ${filled ? 'filled' : ''}`}
      rel="noreferrer"
    >
      <span>
        <FormattedMessage id={text} defaultMessage="Solicitar info" />
      </span>
      {withIcon && (
        <div className="image-wrapper">
          <img src={arrow} alt="logo" />
        </div>
      )}
    </a>
  )
}
